










































































import { CourseStatus, CourseVisibility } from '@/jbi-shared/types/jtms.types';
import BaseSwitch from '@/jbi-shared/vue-components/BaseSwitch.vue';
import dayjs from 'dayjs';
import { Vue, Component, PropSync, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
    BaseSwitch
  }
})
export default class PublishRegistrationStatusSelection extends Vue {
  @PropSync('openForRegistration') syncedOpenForRegistration!: boolean;
  @PropSync('requireRegistrationConfirmation')
  syncedRequireRegistrationConfirmation!: boolean;
  @PropSync('visibility') syncedVisibility!: CourseVisibility;
  @PropSync('groupRegistration') syncedGroupRegistration!: boolean;
  @PropSync('enableQuestionnaire', { default: false })
  syncedEnableQuestionnaire!: boolean;
  @PropSync('freeCourse', { default: false }) syncedFreeCourse!: boolean;

  @Prop() courseStartDate!: string;
  @Prop({ default: CourseStatus.DRAFT }) courseStatus!: CourseStatus;
  @Prop({ default: false }) isRegistrationSettings!: boolean;

  shouldDisable: boolean = false;

  @Watch('syncedVisibility', { immediate: true })
  onVisibilityChanged() {
    if (this.syncedVisibility === CourseVisibility.PRIVATE) {
      this.syncedRequireRegistrationConfirmation = true;
      this.shouldDisable = true;
    } else {
      this.shouldDisable = false;
    }
  }

  get shouldDisableOpenRegistration() {
    if (this.courseStartDate && this.courseStatus) {
      const currentDate = dayjs().toDate();
      const startDate = dayjs(this.courseStartDate).toDate();
      return (
        this.courseStatus === CourseStatus.PUBLISHED && currentDate > startDate
      );
    }

    return false;
  }
}
